import React from 'react';

const RegionCard = ({ region, description }) => {
  return (
    <div className="region-card" style={{
      backgroundColor: 'white',
      padding: '25px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
      flex: '1 1 250px',
      minWidth: '250px',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      cursor: 'pointer'
    }}>
      <h3 style={{
        fontSize: '1.3rem',
        marginBottom: '10px',
        color: '#1a73e8'
      }}>{region}</h3>
      <p style={{
        fontSize: '1rem',
        lineHeight: 1.5,
        color: '#555'
      }}>{description}</p>
    </div>
  );
};

const Regions = () => {
  return (
    <section id="regions" style={{
      padding: '80px 5%',
      backgroundColor: 'white'
    }}>
      <h2 style={{
        fontSize: '2.5rem',
        textAlign: 'center',
        marginBottom: '20px',
        color: '#1a73e8'
      }}>Regional Expertise</h2>

      <p style={{
        fontSize: '1.1rem',
        textAlign: 'center',
        maxWidth: '800px',
        margin: '0 auto 50px',
        lineHeight: 1.6,
        color: '#555'
      }}>
        Peerwatt offers specialized knowledge of energy markets across Greece and Southeast Europe,
        combined with comprehensive pan-European modeling capabilities.
      </p>

      <div className="region-grid" style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '25px',
        justifyContent: 'center'
      }}>
        <RegionCard 
          region="Greece" 
          description="Deep expertise in the Greek energy market structure, regulations, and future transitions."
        />
        <RegionCard 
          region="Southeast Europe" 
          description="Comprehensive coverage of SEE energy markets, interconnections, and regional cooperation mechanisms."
        />
        <RegionCard 
          region="Pan-European" 
          description="Integrated modeling of European power, gas and hydrogen markets with cross-border analyses."
        />
      </div>

      {/* Hover interaction styling */}
      <style>{`
        .region-grid:hover .region-card {
          opacity: 0.5;
        }

        .region-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
          opacity: 1 !important;
        }
      `}</style>
    </section>
  );
};

export default Regions;
